import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { loadConsentDetails } from "../../../Redux/actions/consentAction";

import ConsentPicker from "./ConsentPicker/ConsentPicker";
import { Backdrop } from "@mui/material";
import { resetConsentState } from "../../../Redux/reducers/consentSlice";
import ConsentPropertiesModalWrapper from "./ConsentProperties/ConsentPropertiesModalWrapper";
import { CBArea } from "./block.style";
import DropArea from "./DropArea/DropArea";
import CBHeader from "./CBHeader";
import Loader from "../../Common/assets/Loader";

type Props = {
  studyId: string;
  formId: string;
  versionId: string;
  type: "platform" | "study";
  editable: boolean;
  formType?: "consent" | "sunshine";
};

const ConsentBuilder = ({
  formId,
  studyId,
  versionId,
  type,
  editable,
  formType,
}: Props) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.consent.loading);
  const toggle = useAppSelector((state) => state.consent.toggleLoader);

  useEffect(() => {
    if (type === "study" && studyId && formId && versionId) {
      dispatch(
        loadConsentDetails(
          studyId,
          formId,
          versionId,
          "study",
          editable,
          false,
          formType
        )
      );
    } else if (type === "platform" && formId && versionId) {
      dispatch(
        loadConsentDetails(
          studyId,
          formId,
          versionId,
          "platform",
          editable,
          false,
          formType
        )
      );
    }
    return () => {
      dispatch(resetConsentState());
    };
  }, [dispatch, studyId, formId, versionId, type, toggle, editable, formType]);

  return (
    <div className="preview-wrapper">
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}

      <CBHeader />
      <CBArea>
        <ConsentPicker />
        <DropArea />
        <ConsentPropertiesModalWrapper />
      </CBArea>
    </div>
  );
};

export default ConsentBuilder;
